import * as STD          from '@emersya/mpa-std';
import * as CM                from '@emersya/mpa-components-manager';
import { Input }         from '@emersya/mpa-components';

export interface IOMSProcessConfirmationModalComponentValue {

};

export interface IOMSProcessConfirmationModalComponentConfiguration extends Input.Configuration<
	IOMSProcessConfirmationModalComponentValue,
	IOMSProcessConfirmationModalComponentValue
>
{
	readonly fields : string[];
};

export class OMSProcessConfirmationModalComponent extends Input.Component<
	HTMLDivElement,
	IOMSProcessConfirmationModalComponentValue,
	IOMSProcessConfirmationModalComponentValue,
	OMSProcessConfirmationModalComponent,
	IOMSProcessConfirmationModalComponentConfiguration
>
{
	component_DOM : HTMLDivElement;

	override async component_start(ev : STD.events.Event<any, CM.Component<any, any>>) {
		await super.component_start(ev);
	};

	override isValueTheDefault() {
		return (!!(
			this.value &&
			this.defaultValue &&
			STD.object.hasSameContentDeeply(this.value, this.defaultValue)
		));
	};

	override deserialize(x : IOMSProcessConfirmationModalComponentValue) {
		return (<IOMSProcessConfirmationModalComponentValue> <any> x);
	};

	// override async component_onActivationChange(event : STD.events.Event<any, CM.Component<any, any>>) {
	// 	await super.component_onActivationChange(event);
	// 	if (event.subType === 'enabled') {
	// 		if (!this.component_parent || !this.component_parent.component_parent) {
	// 			return;
	// 		}
	// 		const id = 'modal-' + this.component_parent.component_parent.id;
	// 		document.body.classList.add(id);

	// 	} else {
	// 		if (!this.component_parent || !this.component_parent.component_parent) {
	// 			return;
	// 		}
	// 		const id = 'modal-' + this.component_parent.component_parent.id;
	// 		document.body.classList.remove(id);
	// 	}
	// };

	async validate(ev : STD.events.Event<CM.Component<any, any>, CM.Component<any, any>>) {
		// if (!this.usePPack) {
		// 	this.component_throwUserError('');
		// }
		// if (!this.value) {
		// 	this.component_throwLibraryError('');
		// }
		void ev;
		// await <any> void 1;
		// const ppack = this.usePPack;
		// this.usePPack = null;
		await this.close();
		await app.processOrder();
		// ppack.resolve(this.value);
	};

	async reset() {
		//do nothing because this need to be more thinked.
	};

	// private usePPack : ReturnType<typeof STD.misc.createPromisePack<IProcessConfirmationModalComponentValue | null>> | null = null;

	async use() {
		// if (this.usePPack) {
		// 	this.component_throwUserError('');
		// }
		// this.usePPack = STD.misc.createPromisePack<IProcessConfirmationModalComponentValue | null>();
		const container = this.component_parent?.component_parent;
		if (!container) {
			this.component_throwLibraryError('', {});
		}
		if (container.component_isDisabled) {
			await container.component_enable();
		}
		if (this.component_isDisabled) {
			await this.component_enable();
		}
		// return await this.usePPack.promise;
	};


	private async close() {
		const container = this.component_parent?.component_parent;
		if (!container) {
			this.component_throwLibraryError('', {});
		}
		if (!this.component_isDisabled) {
			await this.component_disable();
		}
		if (!container.component_isDisabled) {
			await container.component_disable();
		}
		// this.usePPack = null;
	};

	// async unuse() {
	// 	if (!this.usePPack) {
	// 		this.component_throwUserError('');
	// 	}
	// 	await this.close();
	// 	const ppack = this.usePPack;
	// 	this.usePPack = null;
	// 	ppack.resolve(null);
	// };

	serialize() {
		return {}; // Hmm why this component is an input???!
	};

	constructor(
		descriptor : ConstructorParameters<typeof CM.Component>[0],
		configuration : IOMSProcessConfirmationModalComponentConfiguration
	)
	{
		super(descriptor, configuration);
		this.component_DOM = <HTMLDivElement> STD.DOM.factory({});
	};
};
export namespace NS {
	export type Component = OMSProcessConfirmationModalComponent;
	export const Component = OMSProcessConfirmationModalComponent;
	export type Configuration = IOMSProcessConfirmationModalComponentConfiguration;
}
import './OMSProcessConfirmationModal.scss';
import manifestXMLSource from './OMSProcessConfirmationModal.xml';

CM.Manager.declare({
	id :       'oms-processConfirmationModal',
	type :     OMSProcessConfirmationModalComponent,
	manifest : manifestXMLSource
});
